// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"search_wrapper__P2lKj","search":"search_search__EGqv3","reset":"search_reset__3ZhYN"};